import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';

import rootReducer from 'store/reducers';
import rootSaga from 'store/sagas';

// saga 미들웨어를 생성합니다.
const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const enhancer = process.env.NODE_ENV === 'production'
    ? compose(applyMiddleware(...middleware)) : composeWithDevTools(applyMiddleware(...middleware));

export const history = createBrowserHistory()

// 스토어에 mount 합니다.
const store = createStore(
  rootReducer(history),
  enhancer
)

// 그리고 saga를 실행합니다.
sagaMiddleware.run(rootSaga);

export default store;